module.exports = __webpack_public_path__ + "img/pic_subject_biology.8a7db106.png";